module.exports = __webpack_public_path__ + "img/ico_curtain_1.91c33492.png";